const reloginErrorMarkers = [
  'login_required',
  'consent_required',
  'interaction_required',
  'invalid_grant',
  'missing_refresh_token',
];

export function shouldRelogin(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const status = (error as { status?: number }).status;
  if (status === 401) return true;

  const rawError = (error as { error?: string }).error ?? '';
  const description = (error as { error_description?: string }).error_description ?? '';
  const message = (error as { message?: string }).message ?? '';
  const combined = `${rawError} ${description} ${message}`.toLowerCase();
  return reloginErrorMarkers.some((marker) => combined.includes(marker));
}
